import React, { useState } from 'react';
import PropTypes, { number, string } from 'prop-types';
import { List, Typography, Spin } from 'antd';
import logoPdf from 'assets/images/GuiasUsuarios/Guias_PDF.svg';
import { getRecurso } from 'actions/recursosGluster.actions';
import { VisualizerGuiadePDF } from '../VisualizerGuiadePDF/VisualizerGuiadePDF';
// import { ModalPdf } from 'components/ModalPdf/ModalPdf';
import './ContenedorGuias.scss';

const ContenedorGuias = ({ logo, textLogo, guiadesDocuments }) => {
  const [guiaFile, setGuiaFile] = useState(null);
  const [loadingGuia, setLoadingGuia] = useState(false);
  const [isModalPdfOpen, setIsModalPdfOpen] = useState(false);

  const fetchGetRecurso = async (urlParam) => {
    try {
      const { success, resources } = await getRecurso({
        urlRecurso: urlParam
      });
      if (success) {
        setGuiaFile(resources.data.archivo);
      }
    } catch (error) {
      console.log('Error en la petición del recurso de la guía', error);
    } finally {
      setLoadingGuia(false);
    }
  };

  const guiasList = () => {
    const handleClick = (urlItem) => {
      setLoadingGuia(true);
      fetchGetRecurso(urlItem);
      setIsModalPdfOpen(true);
    };

    return (
      <List
        dataSource={guiadesDocuments}
        renderItem={(item) => (
          <List.Item>
            <Typography.Link
              href="#"
              style={{
                fontSize: '0.9rem',
                color: '#228F99',
                textDecoration: 'underline',
                fontWeight: '500'
              }}
              onClick={() => handleClick(item.urlDocumento)}>
              <img
                src={logoPdf}
                alt=""
                style={{
                  marginRight: 8,
                  width: 17,
                  height: 17,
                  fill: '#a867ee'
                }}
              />
              {item.nombreDocumento}
            </Typography.Link>
          </List.Item>
        )}
      />
    );
  };

  return (
    <div className="contenedor-guias-links">
      <div className="guias-icon-list-container">
        <div className={textLogo ? 'contenedor-guias-screen' : 'contenedor-guias-screen-default'}>
          <img className="image-screen" src={logo} alt="" />
          {textLogo ? (
            <div className="name-screen-container">{textLogo}</div>
          ) : (
            <div className="name-screen-container-default">
              Sistema Integral de Monitoreo de
              <br />
              Actividades de Campo
            </div>
          )}
        </div>
        <div>{textLogo ? guiasList() : <>&nbsp;</>}</div>
      </div>
      {loadingGuia ? (
        <div className="spinner-guiade-pdf">
          <Spin size="large" />
        </div>
      ) : (
        <VisualizerGuiadePDF
          open={isModalPdfOpen}
          pdfGuia={guiaFile}
          callback={() => {
            setIsModalPdfOpen(false);
            setGuiaFile(null);
          }}
          destroyOnClose
        />
      )}
    </div>
  );
};

export default ContenedorGuias;

ContenedorGuias.propTypes = {
  logo: PropTypes.string.isRequired,
  textLogo: PropTypes.string,
  guiadesDocuments: PropTypes.arrayOf(
    PropTypes.shape({
      icono: string,
      idDocumento: number,
      nombreDocumento: string,
      urlDocumento: string
    }).isRequired
  ).isRequired
};

ContenedorGuias.defaultProps = {
  textLogo: null
};
